<template>
    <span>
        <el-input-number v-if="showInput" class="filterItem-value" v-model="filterItem.value[0]" :controls="false"/>

        <span class="filterItem-value" v-if="showBetween">
            <el-input-number v-model="filterItem.value[0]" :controls="false" style="width: 120px;"/>
                <span style="width: 20px;text-align: center;">至</span>
            <el-input-number v-model="filterItem.value[1]" :controls="false" style="width: 120px;"/>
        </span>
    </span>
</template>

<style>
    
</style>

<script>
    import baseFilter from "../../BaseFilter"

    export default {
        name:"NumericFieldFilter",
        mixins:[baseFilter]
    }
</script>